import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, PercentPipe } from '@angular/common';

@Component({
  selector: 'comp-criteria-analysis-result',
  imports: [TranslateModule, PercentPipe, NgClass],
  templateUrl: 'criteria-analysis-result.component.html',
  styleUrls: ['criteria-analysis-result.component.scss'],
})
export class CriteriaAnalysisResultComponent {
  criterionMetCssClass = computed(() => {
    if (this.criterionMet()) {
      return '-met';
    } else {
      return '-not-met';
    }
  });

  confidenceCssClass = computed(() => {
    if (this.confidence() > 0.9) {
      return '-high';
    } else if (this.confidence() > 0.8) {
      return '-medium';
    } else {
      return '-low';
    }
  });

  criterionMet = input.required<boolean>();
  confidence = input.required<number>();
}
